import * as React from 'react';

export function TargetAudience() {
  return (
    <section className="edu-audience">
      <style>{`
        .edu-audience {
          padding: 72px 24px;
          background: #fff;
        }
        .edu-audience-inner {
          max-width: 800px;
          margin: 0 auto;
        }
        .edu-audience h2 {
          font-size: 28px;
          font-weight: 800;
          color: #1a1a1a;
          margin: 0 0 36px;
          text-align: center;
        }
        .edu-audience-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 40px;
        }
        .edu-audience-col h3 {
          font-size: 16px;
          font-weight: 700;
          color: #1EAA25;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          margin: 0 0 16px;
        }
        .edu-audience-col ul {
          list-style: none;
          padding: 0;
          margin: 0;
        }
        .edu-audience-col li {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 10px 0;
          font-size: 16px;
          color: #333;
          border-bottom: 1px solid #f0f0f0;
        }
        .edu-audience-col li:last-child {
          border-bottom: none;
        }
        .edu-audience-col li i {
          color: #1EAA25;
          font-size: 14px;
          flex-shrink: 0;
          width: 20px;
          text-align: center;
        }
        @media (max-width: 640px) {
          .edu-audience-grid {
            grid-template-columns: 1fr;
            gap: 32px;
          }
          .edu-audience h2 {
            font-size: 24px;
          }
        }
      `}</style>
      <div className="edu-audience-inner">
        <h2>Instituciones que ya confían en nosotros</h2>
        <div className="edu-audience-grid">
          <div className="edu-audience-col">
            <h3>Trabajamos con</h3>
            <ul>
              <li><i className="fa fa-school" /> Colegios y escuelas</li>
              <li><i className="fa fa-child" /> Jardines de infantes</li>
              <li><i className="fa fa-graduation-cap" /> Universidades</li>
              <li><i className="fa fa-utensils" /> Escuelas de gastronomía</li>
              <li><i className="fa fa-building" /> Residencias universitarias</li>
            </ul>
          </div>
          <div className="edu-audience-col">
            <h3>Que buscan</h3>
            <ul>
              <li><i className="fa fa-check" /> Frescura y calidad constante</li>
              <li><i className="fa fa-check" /> Entrega puntual y programada</li>
              <li><i className="fa fa-check" /> Facturación formal</li>
              <li><i className="fa fa-check" /> Precios predecibles</li>
              <li><i className="fa fa-check" /> Trazabilidad para auditorías</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
